import React from 'react';
import { ArrowRight, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';
import { heroData } from '../data/mock';

export const HeroSection = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="min-h-screen flex items-center justify-center bg-white relative overflow-hidden">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-[0.02]">
        <div className="absolute top-1/4 right-1/4 w-96 h-96 rounded-full border border-gray-300" />
        <div className="absolute bottom-1/4 left-1/4 w-64 h-64 rounded-full border border-gray-300" />
      </div>

      <div className="max-w-6xl mx-auto px-6 lg:px-12 py-32 text-center relative z-10">
        {/* Main Headline */}
        <h1 className="text-4xl sm:text-5xl lg:text-7xl font-extralight text-black leading-tight tracking-tight mb-8 animate-fade-in">
          {heroData.headline}
        </h1>

        {/* Subheadline */}
        <p className="text-lg sm:text-xl text-gray-500 font-light mb-4 tracking-wide">
          {heroData.subheadline}
        </p>

        {/* Description */}
        <p className="text-base sm:text-lg text-gray-400 font-light max-w-2xl mx-auto mb-12">
          {heroData.description}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-wrap items-center justify-center gap-4">
          <Button
            onClick={() => scrollToSection('#services')}
            className="bg-rose-600 text-white hover:bg-rose-700 rounded-full px-8 py-6 text-sm font-normal group"
          >
            Explore My Work
            <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform duration-200" />
          </Button>
          <Button
            variant="outline"
            onClick={() => scrollToSection('#projects')}
            className="border-rose-200 text-rose-600 hover:bg-rose-50 hover:border-rose-300 rounded-full px-8 py-6 text-sm font-normal"
          >
            View Ventures
          </Button>
          <Button
            variant="ghost"
            onClick={() => scrollToSection('#contact')}
            className="text-rose-500 hover:text-rose-700 hover:bg-transparent rounded-full px-8 py-6 text-sm font-normal"
          >
            Contact Me
          </Button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 animate-bounce">
        <button
          onClick={() => scrollToSection('#about')}
          className="text-gray-300 hover:text-gray-500 transition-colors duration-200"
        >
          <ChevronDown size={32} strokeWidth={1} />
        </button>
      </div>
    </section>
  );
};
